import React from "react";

import Button from "../elements/Button.tsx";
import Header from "../elements/Header.tsx";
import Modal, { ModalProps } from "../elements/Modal.tsx";

const ValidationErrorModal: React.FC<Pick<ModalProps, "onClose">> = ({
  onClose,
}) => {
  return (
    <Modal onClose={onClose}>
      <Header size="2xl" hideUnderline className="mb-4">
        Required fields missing
      </Header>
      <div className="mb-4">
        Please complete all the required selections before continuing.
      </div>
      <Button onClick={onClose}>Continue</Button>
    </Modal>
  );
};

export default ValidationErrorModal;
